// Plays a ready 3D flyover video full screen. Builds a black full-viewport overlay with a looping
// <video> and a close button, and also requests true browser fullscreen where available (the call
// site is a user gesture, so it's allowed).
//
// Lives here rather than in entrypoints/recordings.ts because two surfaces open the same player: the
// recording overview's gallery thumbnail, and the flyover tile that leads a comment's media strip
// (CommentFlyoverThumb.vue), which renders on hike pages too.
import { i18n } from '../i18n';

export function openFlyoverVideoFullscreen(videoUrl: string): void {
  const overlay = document.createElement('div');
  overlay.className = 'flyover-fullscreen-overlay';

  const video = document.createElement('video');
  video.className = 'flyover-fullscreen-overlay__video';
  video.src = videoUrl;
  video.controls = true;
  video.autoplay = true;
  video.loop = true;
  video.playsInline = true;

  const close = document.createElement('button');
  close.className = 'flyover-fullscreen-overlay__close material-icons';
  close.setAttribute('aria-label', i18n.global.t('utils.open_flyover_video_fullscreen.close_video'));
  close.textContent = 'close';

  const dismiss = () => {
    if (document.fullscreenElement) document.exitFullscreen?.().catch(() => {});
    overlay.remove();
    document.removeEventListener('keydown', onKey);
  };
  const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') dismiss(); };

  close.addEventListener('click', dismiss);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) dismiss(); });
  document.addEventListener('keydown', onKey);

  overlay.appendChild(video);
  overlay.appendChild(close);
  document.body.appendChild(overlay);

  overlay.requestFullscreen?.().catch(() => {});
  video.play().catch(() => {});
}

export default openFlyoverVideoFullscreen;
